// HOLDOUTGROUP : holdout-q3-2026

// fuction to check holdout group ann add class ab-enabled
const checkHoldout = (_) => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-beach-riot-q3-2026', 'OFF');
  if (holdoutGroup != 'holdout-beach-riot-q3-2026') {
    document.documentElement.classList.add('ab-enabled');
    window.ab_enabled = true;
  }
};

(() => {
  if (!document.querySelector('[data-graphics-pdp="true"]')) {
    window.growthbook_queue = window.growthbook_queue || [];
    window.growthbook_queue.push((gb) => {
      // Function that uses feature flags to make changes to the page
      const applyFeatureFlags = () => {};
      // check holdout to set ab test
      checkHoldout();
      // Call your function initially plus whenever new data is received
      applyFeatureFlags();
      document.addEventListener('growthbookdata', (_) => {
        checkHoldout();
        applyFeatureFlags();
      });
    });
  }
})();
